export default class AchievementDetailsResponse {
    constructor(supportedLocales = []) {
        this.translations = [];
        supportedLocales.forEach((element) => {
            this.translations[element] = {
                title: '',
                description: '<span></span>',
                pushMessage: '',
                verificationInstruction: '<span></span>',
            };
        });

        this.coinsToEarn = null;
        this.challengeType = null;
        this.activityType = null;
        this.relatedToCommuteWork = null;
        this.measureUnit = null;
        this.goalValue = null;
        this.action = null;
        this.transport = null;
        this.sendPushWhenCompleted = true;
        this.supportedLocales = supportedLocales;
    }

    static assign(from, to) {
        if (from) {
            to.id = from.id;
            to.status = from.status;
            to.coinsToEarn = from.coinsToEarn;
            to.goalValue = from.goalValue;
            to.challengeType = from.challengeType;
            to.activityType = from.activityType;
            to.measureUnit = from.measureUnit;
            to.relatedToCommuteWork = from.relatedToCommuteWork;
            to.action = from.action;
            to.photo = from.photo;
            to.transport = from.transport;
            to.sendPushWhenCompleted = from.sendPushWhenCompleted;
            const locales = (to && Array.isArray(to.supportedLocales) && to.supportedLocales.length > 0)
                ? to.supportedLocales
                : Object.keys(from?.translations || {});
            locales.forEach((element) => {
                to.translations[element] = {
                    title: from?.translations?.[element]?.title,
                    description: from?.translations?.[element]?.description,
                    pushMessage: from?.translations?.[element]?.pushMessage,
                };
            });
        } else {
            to = new AchievementDetailsResponse();
        }
    }

    static copy(to, from) {
        AchievementDetailsResponse.assign(from, to);
        return to;
    }
}
